export default "__VITE_PUBLIC_ASSET__3c8be603__"